import { pdf } from "@react-pdf/renderer";
import React from "react";
import { ReportPdfDocument, type PdfReportData } from "./ReportPdfTemplate";

export type { PdfReportData };

/**
 * Generates a professional PDF from structured report data using a React-PDF
 * template. Page breaks are handled natively by the renderer — sections and
 * table rows are never split across pages.
 */
export async function downloadReportPdf(
  data: PdfReportData,
  filename = "vendor-evaluation-report.pdf",
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const doc = React.createElement(ReportPdfDocument, { data }) as any;
  const blob = await pdf(doc).toBlob();

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
